/**
 * 中国省份GPS坐标工具类
 * 包含省份中心坐标和根据GPS获取省份的功能
 * 省份顺序：广东省, 北京市, 天津市, 上海市, 重庆市, 河北省, 山西省, 辽宁省,
 * 吉林省, 黑龙江省, 江苏省, 浙江省, 安徽省, 福建省, 江西省, 山东省,
 * 河南省, 湖北省, 湖南省, 海南省, 四川省, 贵州省, 云南省,
 * 陕西省, 甘肃省, 青海省, 台湾省, 香港特别行政区, 澳门特别行政区,
 * 内蒙古自治区, 广西壮族自治区, 西藏自治区, 宁夏回族自治区, 新疆维吾尔自治区
 */

// 省份中心坐标映射（用于地图定位）
export const provinceCenterMap = {
  '广东省': [113.2644, 23.1291],
  '北京市': [116.4074, 39.9042],
  '天津市': [117.1902, 39.1256],
  '上海市': [121.4737, 31.2304],
  '重庆市': [106.5044, 29.5582],
  '河北省': [114.4995, 38.1006],
  '山西省': [112.5624, 37.8735],
  '辽宁省': [123.4315, 41.8057],
  '吉林省': [125.3245, 43.8968],
  '黑龙江省': [126.6424, 45.7567],
  '江苏省': [118.7674, 32.0415],
  '浙江省': [120.1536, 30.2875],
  '安徽省': [117.2842, 31.8612],
  '福建省': [119.3062, 26.0753],
  '江西省': [115.8922, 28.6765],
  '山东省': [117.0009, 36.6758],
  '河南省': [113.6654, 34.757],
  '湖北省': [114.2986, 30.5844],
  '湖南省': [112.9823, 28.1941],
  '海南省': [109.8305, 19.2085],
  '四川省': [104.0657, 30.6595],
  '贵州省': [106.7135, 26.5783],
  '云南省': [102.7123, 25.0406],
  '陕西省': [108.948, 34.2632],
  '甘肃省': [103.8236, 36.058],
  '青海省': [101.7809, 36.6209],
  '台湾省': [121.5200, 25.0300],
  '香港特别行政区': [114.1694, 22.3193],
  '澳门特别行政区': [113.5431, 22.1987],
  '内蒙古自治区': [111.6708, 40.8183],
  '广西壮族自治区': [108.320, 22.824],
  '西藏自治区': [91.1409, 29.6563],
  '宁夏回族自治区': [106.2782, 38.4664],
  '新疆维吾尔自治区': [87.6177, 43.7928]
}

// 省份边界范围（用于GPS定位）- 包含全部34个省级行政区
const provinceBoundaries = [
  // 直辖市
  { name: '北京市', minLat: 39.4, maxLat: 41.1, minLng: 115.4, maxLng: 117.5 },
  { name: '天津市', minLat: 38.8, maxLat: 40.2, minLng: 116.7, maxLng: 118.0 },
  { name: '上海市', minLat: 30.7, maxLat: 31.9, minLng: 120.8, maxLng: 122.0 },
  { name: '重庆市', minLat: 28.0, maxLat: 32.0, minLng: 105.5, maxLng: 110.0 },

  // 华北地区
  { name: '河北省', minLat: 35.0, maxLat: 42.0, minLng: 113.0, maxLng: 120.0 },
  { name: '山西省', minLat: 34.5, maxLat: 40.5, minLng: 110.0, maxLng: 114.5 },

  // 东北地区
  { name: '辽宁省', minLat: 38.5, maxLat: 43.0, minLng: 118.0, maxLng: 125.0 },
  { name: '吉林省', minLat: 40.5, maxLat: 46.0, minLng: 121.0, maxLng: 131.0 },
  { name: '黑龙江省', minLat: 43.0, maxLat: 53.0, minLng: 121.0, maxLng: 135.0 },

  // 华东地区
  { name: '江苏省', minLat: 30.5, maxLat: 35.0, minLng: 116.5, maxLng: 122.0 },
  { name: '浙江省', minLat: 27.0, maxLat: 31.0, minLng: 118.0, maxLng: 123.0 },
  { name: '安徽省', minLat: 29.5, maxLat: 34.5, minLng: 114.5, maxLng: 119.5 },
  { name: '福建省', minLat: 23.5, maxLat: 28.5, minLng: 115.8, maxLng: 120.5 },
  { name: '江西省', minLat: 24.0, maxLat: 30.0, minLng: 113.5, maxLng: 118.5 },
  { name: '山东省', minLat: 34.5, maxLat: 38.5, minLng: 114.5, maxLng: 122.5 },

  // 华中地区
  { name: '河南省', minLat: 31.0, maxLat: 36.5, minLng: 110.5, maxLng: 116.5 },
  { name: '湖北省', minLat: 29.0, maxLat: 33.5, minLng: 108.5, maxLng: 116.0 },
  { name: '湖南省', minLat: 24.5, maxLat: 30.0, minLng: 108.5, maxLng: 114.0 },

  // 华南地区
  { name: '广东省', minLat: 20.0, maxLat: 25.5, minLng: 109.5, maxLng: 117.5 },
  { name: '海南省', minLat: 18.0, maxLat: 20.0, minLng: 108.5, maxLng: 111.0 },
  { name: '台湾省', minLat: 21.5, maxLat: 25.5, minLng: 119.5, maxLng: 122.5 },
  { name: '香港特别行政区', minLat: 22.2, maxLat: 22.6, minLng: 113.8, maxLng: 114.4 },
  { name: '澳门特别行政区', minLat: 22.1, maxLat: 22.2, minLng: 113.5, maxLng: 113.6 },
  { name: '广西壮族自治区', minLat: 21.0, maxLat: 26.5, minLng: 104.5, maxLng: 112.0 },

  // 西南地区
  { name: '四川省', minLat: 26.0, maxLat: 34.0, minLng: 97.5, maxLng: 108.5 },
  { name: '贵州省', minLat: 24.5, maxLat: 29.2, minLng: 103.5, maxLng: 109.5 },
  { name: '云南省', minLat: 21.0, maxLat: 29.0, minLng: 97.5, maxLng: 106.0 },
  { name: '西藏自治区', minLat: 27.0, maxLat: 37.0, minLng: 78.0, maxLng: 98.0 },

  // 西北地区
  { name: '陕西省', minLat: 31.5, maxLat: 39.5, minLng: 105.5, maxLng: 111.0 },
  { name: '甘肃省', minLat: 32.0, maxLat: 42.0, minLng: 92.0, maxLng: 108.5 },
  { name: '青海省', minLat: 31.5, maxLat: 39.0, minLng: 89.0, maxLng: 103.0 },
  { name: '宁夏回族自治区', minLat: 35.0, maxLat: 39.0, minLng: 104.0, maxLng: 107.0 },
  { name: '新疆维吾尔自治区', minLat: 34.0, maxLat: 49.0, minLng: 73.0, maxLng: 96.0 }
]

/**
 * 根据GPS坐标获取省份名称
 * @param {number} lat 纬度
 * @param {number} lng 经度
 * @returns {string} 省份名称，未找到返回'未知'
 */
export function getProvinceByGps(lat, lng) {
  if (!lat || !lng || lat === 0 || lng === 0) {
    return '未知'
  }

  for (const boundary of provinceBoundaries) {
    if (lat >= boundary.minLat && lat <= boundary.maxLat &&
      lng >= boundary.minLng && lng <= boundary.maxLng) {
      return boundary.name
    }
  }

  return '未知'
}

/**
 * 获取省份中心坐标
 * @param {string} provinceName 省份名称
 * @returns {Array} [经度, 纬度]
 */
export function getProvinceCenter(provinceName) {
  return provinceCenterMap[provinceName] || [113.2644, 23.1291]
}

/**
 * 获取所有省份列表
 * @returns {Array} 省份名称数组
 */
export function getAllProvinces() {
  return Object.keys(provinceCenterMap)
}

/**
 * 判断两个坐标是否在同一省份
 * @param {number} lat1 纬度1
 * @param {number} lng1 经度1
 * @param {number} lat2 纬度2
 * @param {number} lng2 经度2
 * @returns {boolean}
 */
export function isSameProvince(lat1, lng1, lat2, lng2) {
  const province1 = getProvinceByGps(lat1, lng1)
  const province2 = getProvinceByGps(lat2, lng2)
  return province1 === province2
}

/**
 * 根据省份名称获取显示名称（用于下拉框等）
 * @param {string} provinceName 省份名称
 * @returns {string}
 */
export function getProvinceDisplayName(provinceName) {
  if (!provinceName || provinceName === '未知') return '全国'
  return provinceName
}

export default {
  provinceCenterMap,
  provinceBoundaries,
  getProvinceByGps,
  getProvinceCenter,
  getAllProvinces,
  isSameProvince,
  getProvinceDisplayName
}
